const INPUT_STYLE = {
  width: '100%',
  border: 'none',
  background: 'transparent',
  fontSize: '13px',
  color: '#2b2b2b',
  fontFamily: 'inherit',
  padding: '6px 8px',
  outline: 'none',
  borderRadius: '4px',
  boxSizing: 'border-box',
};

const ADDER_PRESETS = [
  'Installation',
  'Haul Away',
  'Trip Charge',
  'Misc Labor',
  'Paint / Stain',
  'Permit',
  'Other',
];

const CELL = {
  borderRight: '1px solid rgba(139,69,19,0.07)',
  verticalAlign: 'middle',
  padding: '0',
};

export default function AdderRow({ row, onChange, onRemove }) {
  function update(field, value) { onChange(row.id, field, value); }

  const qty   = parseFloat(row.qty)   || 0;
  const price = parseFloat(row.price) || 0;
  const total = qty * price;

  return (
    <tr style={{
      background: 'rgba(106,26,106,0.03)',
      borderBottom: '1px solid rgba(106,26,106,0.08)',
      borderLeft: '3px solid rgba(106,26,106,0.3)',
    }}>

      {/* # indicator */}
      <td style={{ ...CELL, width: '36px', textAlign: 'center' }}>
        <span style={{ fontSize: '10px', color: '#9a4a9a', fontWeight: '800', display: 'block', padding: '14px 0' }}>
          +
        </span>
      </td>

      {/* Adder tag — fixed, not changeable */}
      <td style={{ ...CELL, width: '130px', padding: '10px 8px', textAlign: 'center' }}>
        <span style={{
          display: 'inline-flex', alignItems: 'center', gap: '5px',
          padding: '5px 10px', borderRadius: '20px',
          border: '1px solid rgba(106,26,106,0.25)',
          background: 'rgba(106,26,106,0.08)',
          color: '#6a1a6a', fontSize: '12px', fontWeight: '600',
          whiteSpace: 'nowrap',
        }}>
          ➕ Adder
        </span>
      </td>

      {/* Qty */}
      <td style={{ ...CELL, width: '56px' }}>
        <input
          type="number"
          value={row.qty}
          min="0"
          placeholder="1"
          onChange={e => update('qty', e.target.value)}
          style={{ ...INPUT_STYLE, textAlign: 'center' }}
        />
      </td>

      {/* Description with presets */}
      <td style={{ ...CELL, minWidth: '180px' }}>
        <input
          type="text"
          list={`adder-presets-${row.id}`}
          value={row.description}
          placeholder="Adder description..."
          onChange={e => update('description', e.target.value)}
          style={{ ...INPUT_STYLE }}
        />
        <datalist id={`adder-presets-${row.id}`}>
          {ADDER_PRESETS.map(p => <option key={p} value={p} />)}
        </datalist>
      </td>

      {/* Room */}
      <td style={{ ...CELL, width: '115px' }}>
        <input
          type="text"
          value={row.room}
          placeholder="Room..."
          onChange={e => update('room', e.target.value)}
          style={{ ...INPUT_STYLE }}
        />
      </td>

      {/* Size */}
      <td style={{ ...CELL, width: '105px' }}>
        <input
          type="text"
          value={row.size}
          placeholder="—"
          onChange={e => update('size', e.target.value)}
          style={{ ...INPUT_STYLE }}
        />
      </td>

      {/* UI */}
      <td style={{ ...CELL, width: '80px' }}>
        <input
          type="text"
          value={row.ui}
          placeholder="—"
          onChange={e => update('ui', e.target.value)}
          style={{ ...INPUT_STYLE }}
        />
      </td>

      {/* Unit Price */}
      <td style={{ ...CELL, width: '95px' }}>
        <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '8px' }}>
          <span style={{ fontSize: '12px', color: '#9a4a9a', marginRight: '2px', flexShrink: 0 }}>$</span>
          <input
            type="number"
            value={row.price}
            min="0"
            step="0.01"
            placeholder="0.00"
            onChange={e => update('price', e.target.value)}
            style={{ ...INPUT_STYLE, paddingLeft: '2px' }}
          />
        </div>
      </td>

      {/* Total */}
      <td style={{ ...CELL, width: '95px', textAlign: 'right', paddingRight: '12px', borderRight: 'none' }}>
        <span style={{
          fontSize: '13px',
          fontWeight: '700',
          color: total > 0 ? '#6a1a6a' : '#ddd',
          fontFamily: 'monospace',
        }}>
          ${total.toFixed(2)}
        </span>
      </td>

      {/* Remove */}
      <td style={{ ...CELL, width: '64px', textAlign: 'center', borderRight: 'none' }}>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '0 4px' }}>
          <button
            type="button"
            onClick={() => onRemove(row.id)}
            title="Remove adder"
            style={{
              width: '26px', height: '26px', borderRadius: '6px',
              border: '1px solid rgba(220,50,50,0.2)',
              background: 'transparent', cursor: 'pointer',
              fontSize: '15px', color: '#cc3333',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'all 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(220,50,50,0.08)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            ×
          </button>
        </div>
      </td>
    </tr>
  );
}